module.exports = __webpack_public_path__ + "interactiveApp/KurzByk/media/1 Licka.jpg";